import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Pipe, NgModule } from '@angular/core';
import moment from 'moment-timezone';
import { DATE_TIME_MOMENT_FORMAT } from '@tangilla/tg-ng-models/src/lib/constants';
import { StringUtils, transformEnumToArray } from '@tangilla/tg-ng-common/src/lib/utils';
import * as i1 from '@angular/platform-browser';

class DatePipe {
    constructor() {
    }
    initialize(timezone) {
        this.timezone = timezone;
        return this;
    }
    transform(value, mode, shouldApply, timezone, useFromNow) {
        if (!value && shouldApply) {
            return 'N/A';
        }
        else {
            if (!value) {
                return '';
            }
        }
        value = moment(value);
        if (useFromNow) {
            return value.fromNow();
        }
        if (mode === 'calendarMobile') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.full);
            }
            return value.format(DATE_TIME_MOMENT_FORMAT.calendar_mobile);
        }
        if (mode === 'both') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.full);
            }
            return value.format(DATE_TIME_MOMENT_FORMAT.full);
        }
        else if (mode === 'time') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.time);
            }
            return value.format(DATE_TIME_MOMENT_FORMAT.time);
        }
        else if (mode === 'timezoneDate') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.date);
            }
        }
        else if (mode === 'month-year') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.monthyear);
            }
            return value.format(DATE_TIME_MOMENT_FORMAT.monthyear);
        }
        else if (mode === 'in-date') {
            if (this.timezone || timezone) {
                return value.tz(this.timezone ? this.timezone : timezone).format(DATE_TIME_MOMENT_FORMAT.in_date);
            }
            return value.format(DATE_TIME_MOMENT_FORMAT.in_date);
        }
        if (this.timezone || timezone) {
            if (this.timezone === 'UTC') {
                return value.tz(this.timezone).format(DATE_TIME_MOMENT_FORMAT.date);
            }
        }
        return value.format(DATE_TIME_MOMENT_FORMAT.date);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: DatePipe, name: "tgDate" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: DatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgDate'
                }]
        }], ctorParameters: function () { return []; } });

class CapitalizePipe {
    constructor() {
    }
    transform(value = '', multipleWords, onlyCapital) {
        return StringUtils.capitalize(value, multipleWords, onlyCapital);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapitalizePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: CapitalizePipe, name: "tgCapitalize" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: CapitalizePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgCapitalize'
                }]
        }], ctorParameters: function () { return []; } });

class FormatHourPipe {
    transform(value, args) {
        if (value) {
            return moment(value, 'hh:mm:ss').format('hh:mm A');
        }
        else {
            return value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatHourPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: FormatHourPipe, name: "tgFormatHour" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FormatHourPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgFormatHour'
                }]
        }] });

class MoneyPipe {
    transform(value, addDollarSign = true, fixedNumber = 2) {
        if (value || value === 0) {
            const valueSign = Math.sign(value);
            return `${valueSign === -1 ? '-' : ''}${addDollarSign ? '$' : ''}${(Math.round((valueSign === -1 ? value * -1 : value) * 100) / 100).toFixed(fixedNumber).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MoneyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: MoneyPipe, name: "tgMoney" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: MoneyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgMoney'
                }]
        }] });

class NotApplyPipe {
    transform(value, args) {
        let notApplianceMessage = '-';
        if (args && args.length > 1) {
            notApplianceMessage = args[0];
        }
        if (!value || value === '') {
            return notApplianceMessage;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NotApplyPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: NotApplyPipe, name: "tgNotApply" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: NotApplyPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgNotApply'
                }]
        }] });

class PhoneNumberPipe {
    constructor() {
    }
    transform(value) {
        if (value) {
            const cleaned = ('' + value).replace(/\D/g, '');
            const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
            return value;
        }
        return 'N/A';
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PhoneNumberPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PhoneNumberPipe, name: "tgPhoneNumber" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PhoneNumberPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgPhoneNumber'
                }]
        }], ctorParameters: function () { return []; } });

class YesOrNoPipe {
    transform(value, args) {
        let yes = 'Yes';
        let no = 'No';
        if (args && args.length > 1) {
            yes = args[0];
            no = args[1];
        }
        if (typeof value === 'boolean') {
            return value === true ? yes : no;
        }
        else if (typeof value === 'string') {
            return (value === 'True' || value === 'true') ? yes : no;
        }
        return value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: YesOrNoPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: YesOrNoPipe, name: "tgYesOrNo" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: YesOrNoPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgYesOrNo'
                }]
        }] });

class EnumToArrayPipe {
    transform(EnumObject, type, isStringValue) {
        return transformEnumToArray(EnumObject, type, isStringValue);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EnumToArrayPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: EnumToArrayPipe, name: "tgEnumToArray" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: EnumToArrayPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgEnumToArray'
                }]
        }] });

class HighlightSearchPipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, searchTerm) {
        if (!searchTerm) {
            return value;
        }
        if (!value) {
            return '';
        }
        const escapedTerm = searchTerm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        const highlighted = value.replace(new RegExp(escapedTerm, 'gi'), (match) => `<span class="highlight">${match}</span>`);
        return this.sanitizer.bypassSecurityTrustHtml(highlighted);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HighlightSearchPipe, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: HighlightSearchPipe, name: "tgHighlightSearch" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: HighlightSearchPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgHighlightSearch'
                }]
        }], ctorParameters: function () { return [{ type: i1.DomSanitizer }]; } });

class PreparedPaymentStatusPipe {
    transform(value = '') {
        return value === 'awaiting_payment' ? 'Submitted' : value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentStatusPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentStatusPipe, name: "tgPreparedPaymentStatus" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentStatusPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgPreparedPaymentStatus'
                }]
        }] });

var dynamicPipe = /*#__PURE__*/Object.freeze({
    __proto__: null,
    CapitalizePipe: CapitalizePipe,
    DatePipe: DatePipe,
    NotApplyPipe: NotApplyPipe,
    PhoneNumberPipe: PhoneNumberPipe
});

class PreparedPaymentTypePipe {
    transform(value = '') {
        return value === 'nip' ? 'Non-Invoiced Product' : value;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentTypePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentTypePipe, name: "tgPreparedPaymentType" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PreparedPaymentTypePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgPreparedPaymentType'
                }]
        }] });

class ContributionsActivityTypeMappingPipe {
    constructor() {
    }
    transform(value) {
        switch (value) {
            case 'pc':
                return 'President Circle';
            case 'contribution':
                return 'Investment';
            default:
                return value;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContributionsActivityTypeMappingPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: ContributionsActivityTypeMappingPipe, name: "tgContributionsActivityTypeMapping" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ContributionsActivityTypeMappingPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'tgContributionsActivityTypeMapping'
                }]
        }], ctorParameters: function () { return []; } });

class PipesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PipesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: PipesModule, declarations: [NotApplyPipe,
            MoneyPipe,
            CapitalizePipe,
            DatePipe,
            PhoneNumberPipe,
            FormatHourPipe,
            YesOrNoPipe,
            EnumToArrayPipe,
            HighlightSearchPipe,
            PreparedPaymentStatusPipe,
            PreparedPaymentTypePipe,
            ContributionsActivityTypeMappingPipe], imports: [CommonModule], exports: [NotApplyPipe,
            MoneyPipe,
            CapitalizePipe,
            PhoneNumberPipe,
            DatePipe,
            FormatHourPipe,
            YesOrNoPipe,
            EnumToArrayPipe,
            HighlightSearchPipe,
            PreparedPaymentStatusPipe,
            PreparedPaymentTypePipe,
            ContributionsActivityTypeMappingPipe] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PipesModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: PipesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        NotApplyPipe,
                        MoneyPipe,
                        CapitalizePipe,
                        DatePipe,
                        PhoneNumberPipe,
                        FormatHourPipe,
                        YesOrNoPipe,
                        EnumToArrayPipe,
                        HighlightSearchPipe,
                        PreparedPaymentStatusPipe,
                        PreparedPaymentTypePipe,
                        ContributionsActivityTypeMappingPipe
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        NotApplyPipe,
                        MoneyPipe,
                        CapitalizePipe,
                        PhoneNumberPipe,
                        DatePipe,
                        FormatHourPipe,
                        YesOrNoPipe,
                        EnumToArrayPipe,
                        HighlightSearchPipe,
                        PreparedPaymentStatusPipe,
                        PreparedPaymentTypePipe,
                        ContributionsActivityTypeMappingPipe
                    ]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CapitalizePipe, ContributionsActivityTypeMappingPipe, DatePipe, EnumToArrayPipe, FormatHourPipe, HighlightSearchPipe, MoneyPipe, NotApplyPipe, PhoneNumberPipe, dynamicPipe as Pipes, PipesModule, PreparedPaymentStatusPipe, PreparedPaymentTypePipe, YesOrNoPipe };
